import { Component } from '@angular/core';

@Component({
  selector: 'app-skeleton',
  template: `
    <div class="grid">
      <div class="col-12 sm:col-4 mb-2">
        <div class="field mb-2">
          <p-skeleton width="60%" height=".9rem" styleClass="mb-2"></p-skeleton>
          <p-skeleton width="100%" height="2rem"></p-skeleton>
        </div>
        <div class="field mb-2">
          <p-skeleton width="60%" height=".9rem" styleClass="mb-2"></p-skeleton>
          <p-skeleton width="100%" height="2rem"></p-skeleton>
        </div>
        <div class="field mb-2">
          <p-skeleton width="60%" height=".9rem" styleClass="mb-2"></p-skeleton>
          <p-skeleton width="100%" height="2rem"></p-skeleton>
        </div>
      </div>
      <div class="col-12 sm:col-4">
        <div class="field mb-2">
          <p-skeleton width="60%" height=".9rem" styleClass="mb-2"></p-skeleton>
          <p-skeleton width="100%" height="2rem"></p-skeleton>
        </div>
        <div class="field mb-2">
          <p-skeleton width="60%" height=".9rem" styleClass="mb-2"></p-skeleton>
          <p-skeleton width="100%" height="2rem"></p-skeleton>
        </div>
      </div>
    </div>
  `,
})
export class SkeletonComponent {
  /**
   * @decription
   * A component that you can display to the user
   * before loading the contents of the application itself.
   */
}
